import { styled } from '@mui/material'

import { IconButton } from '@collaborate-health/uikit'

export const InfoIconButton = styled(IconButton)(({ theme }) => ({ padding: 0 }))

